import {
  normalizeName,
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate
} from '@widergy/web-utils/lib/normalize';

export const fields = {
  NUMBER: 'number',
  NAME: 'name',
  EXPIRY: 'expiry',
  CVC: 'cvc'
};

export const mapFormatToField = {
  [fields.NUMBER]: formatCreditCardNumber,
  [fields.NAME]: normalizeName,
  [fields.EXPIRY]: formatExpirationDate,
  [fields.CVC]: formatCVC
};
